import type { Testimonial } from '@/services/httpServices/websiteService'

/**
 * Patient testimonials for Fast Aid Hospital, Chauddagram. Used as an offline
 * fallback when the website API is unreachable so the `/testimonials` page
 * never renders empty.
 */
export const testimonials: Testimonial[] = [
  {
    id: 'demo-testimonial-1',
    name: 'Rakibul Hasan',
    role: 'Patient',
    title: 'Emergency & Trauma Care',
    quote:
      'My father was brought to the emergency department late at night after a road accident. The doctors attended him within minutes and kept us informed at every step. I am grateful for the quick, caring service.',
    image: '/assets/images/avatar/avatar-1.jpg',
    rating: 5,
    displayOrder: 1,
  },
  {
    id: 'demo-testimonial-2',
    name: 'Shahida Begum',
    role: 'Patient',
    title: 'General Medicine',
    quote:
      'I had a fever for several days and visited the outdoor department. The physician examined me carefully, did the tests on the same day and explained my treatment clearly. The hospital is clean and the staff are very helpful.',
    image: '/assets/images/avatar/avatar-2.jpg',
    rating: 5,
    displayOrder: 2,
  },
  {
    id: 'demo-testimonial-3',
    name: 'Md. Jamal Uddin',
    role: 'Patient',
    title: 'Cardiology',
    quote:
      'After my chest pain I came to Fast Aid Hospital for an ECG and heart checkup. The cardiology team was thorough and helped me control my blood pressure. I now come here for my regular follow-up.',
    image: '/assets/images/avatar/avatar-3.jpg',
    rating: 5,
    displayOrder: 3,
  },
  {
    id: 'demo-testimonial-4',
    name: 'Farhana Akter',
    role: 'Guardian',
    title: 'Pediatrics & Child Health',
    quote:
      'My two-year-old had a high fever and was very restless. The child specialists treated him gently and guided us on home care. They never rushed us and answered all of our questions.',
    image: '/assets/images/avatar/avatar-4.jpg',
    rating: 5,
    displayOrder: 4,
  },
  {
    id: 'demo-testimonial-5',
    name: 'Abdul Karim',
    role: 'Patient',
    title: 'Orthopedics & Trauma',
    quote:
      'I fractured my leg and received treatment here from the first day. The plaster and follow-up care were excellent, and the physiotherapy advice helped me walk normally again. Thank you, Fast Aid Hospital.',
    image: '/assets/images/avatar/avatar-5.jpg',
    rating: 5,
    displayOrder: 5,
  },
  {
    id: 'demo-testimonial-6',
    name: 'Nasima Sultana',
    role: 'Patient',
    title: 'Diagnostic Laboratory & Imaging',
    quote:
      'The laboratory is well organised and the reports were ready the same day. The technician was polite and the test results matched what my doctor expected. Very reliable diagnostic service in Chauddagram.',
    image: '/assets/images/avatar/avatar-6.jpg',
    rating: 5,
    displayOrder: 6,
  },
  {
    id: 'demo-testimonial-7',
    name: 'Mohammad Ali',
    role: 'Patient',
    title: 'General Medicine',
    quote:
      'I have been managing my diabetes at Fast Aid Hospital for over a year. The doctors check my reports, adjust my medicine and always give practical advice about diet and exercise. I feel confident in their care.',
    image: '/assets/images/avatar/avatar-7.jpg',
    rating: 5,
    displayOrder: 7,
  },
  {
    id: 'demo-testimonial-8',
    name: 'Ruma Chowdhury',
    role: 'Patient',
    title: 'Gynecology & Obstetrics',
    quote:
      'The gynecology department treated me with respect and privacy. The doctor listened patiently and the staff supported me throughout. It is reassuring to have this quality of care close to home.',
    image: '/assets/images/avatar/avatar-1.jpg',
    rating: 5,
    displayOrder: 8,
  },
  {
    id: 'demo-testimonial-9',
    name: 'Sujon Mia',
    role: 'Patient',
    title: 'Diagnostic Laboratory & Imaging',
    quote:
      'I needed an X-ray and some blood tests urgently. Everything was done under one roof without running from place to place, and the doctor reviewed the reports the same day. Highly recommended.',
    image: '/assets/images/avatar/avatar-9.jpg',
    rating: 5,
    displayOrder: 9,
  },
]
